export const fullNameRegex = /^[a-zA-Z][a-zA-Z][a-zA-Z\s]*[a-zA-Z]$/;
export const mobileNumberRegex = /^\d{10,15}$/;
export const spacingRegexReplace = /^\s+|\s+$/g;

export function containsOnlyAlphabets(str) {
  // Regular expression to check if the string contains only alphabets
  const regex = /^[a-zA-Z]+$/;

  // Test the string with the regular expression
  return regex.test(str);
}
